// @flow
import React, { type Node } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string,
  htmlFor?: string,
  isDisabled?: boolean,
  isRequired?: boolean,
  label: string | Node,
  labelAdditionalInfo?: string | Node,
};

export const Label = ({
  className,
  htmlFor,
  isDisabled = false,
  isRequired = false,
  label,
  labelAdditionalInfo,
}: Props) => (
  <label
    className={classNames(
      'font-bold inline-block mb-2 text-base align-middle',
      {
        'text-gray-darker': !isDisabled,
        'text-gray-light': isDisabled,
      },
      className,
    )}
    htmlFor={htmlFor}
  >
    {label}
    {isRequired && '*'}
    {labelAdditionalInfo && (
      <span className="ml-2 text-sm text-gray-medium-dark font-normal">{labelAdditionalInfo}</span>
    )}
  </label>
);
